import React, { useState } from "react";
import styles from "./RelatedVideos.module.css";

const RelatedVideos = () => {
  const [videos, setVideos] = useState([
    {
      id: 1,
      url: "https://www.youtube.com/live/iEpJwprxDdk",
      title: "Bloomberg Business News Live",
      tags: ["#Bloomberg", "#Live"],
    },
    {
      id: 2,
      url: "https://youtu.be/H2lPlAmCCcs",
      title:
        "캐나다 CSE거래소에 대해 알아봅시다. 북미의 떠오르는 강자 캐나다의 나스닥.",
      tags: ["#CSE", "#NASDAQ", "#Canada"],
    },
    {
      id: 3,
      url: "https://youtu.be/8UtG77IDemU",
      title: "스타넥스. 캐나다 CSE거래소 상장 뉴스. 진짜 가나요?",
      tags: ["#스타넥스", "#CSE", "#상장"],
    },
  ]);

  // const [newVideo, setNewVideo] = useState({ url: "", title: "", tags: "" });
  const [selectedVideo, setSelectedVideo] = useState(null);

  // 유튜브 ID 추출 함수
  const getYouTubeID = (url) => {
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:.*v=|.*\/))([\w-]+)/
    );
    return match ? match[1] : null;
  };

  // // 입력값 변경 핸들러
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setNewVideo({ ...newVideo, [name]: value });
  // };

  // // 새 영상 추가
  // const handleAddVideo = (e) => {
  //   e.preventDefault();
  //   const videoID = getYouTubeID(newVideo.url);
  //   if (!videoID || !newVideo.title)
  //     return alert("유효한 유튜브 URL과 제목을 입력하세요.");

  //   setVideos([
  //     ...videos,
  //     {
  //       id: videos.length + 1,
  //       url: newVideo.url,
  //       title: newVideo.title,
  //       tags: newVideo.tags.split(",").map((tag) => tag.trim()),
  //     },
  //   ]);

  //   setNewVideo({ url: "", title: "", tags: "" });
  // };

  // 모달 열기
  const openModal = (video) => {
    setSelectedVideo(video);
  };

  // 모달 닫기
  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <section className={styles.relatedVideos}>
      <h2 className={styles.title}>Related Videos</h2>

      {/* 유튜브 영상 추가 폼 
      <form className={styles.form} onSubmit={handleAddVideo}>
        <input
          type="text"
          name="url"
          placeholder="유튜브 영상 URL"
          value={newVideo.url}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="title"
          placeholder="영상 제목"
          value={newVideo.title}
          onChange={handleInputChange}
          required
        />
        <input
          type="text"
          name="tags"
          placeholder="태그 입력 (쉼표로 구분)"
          value={newVideo.tags}
          onChange={handleInputChange}
        />
        <button type="submit">영상 추가</button>
      </form>*/}

      {/* 비디오 목록 */}
      <div className={styles.videoGrid}>
        {videos.map((video) => {
          const videoID = getYouTubeID(video.url);
          return (
            <div
              key={video.id}
              className={styles.videoCard}
              onClick={() => openModal(video)}
            >
              <img
                src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                alt={video.title}
                className={styles.thumbnail}
              />
              <div className={styles.videoInfo}>
                <h3 className={styles.videoTitle}>{video.title}</h3>
                <div className={styles.tags}>
                  {video.tags.map((tag, index) => (
                    <span key={index} className={styles.tag}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* 모달 창 */}
      {selectedVideo && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div
            className={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.closeBtn} onClick={closeModal}>
              ✖
            </div>
            <iframe
              width="100%"
              height="400"
              src={`https://www.youtube.com/embed/${getYouTubeID(
                selectedVideo.url
              )}?autoplay=1`}
              title={selectedVideo.title}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default RelatedVideos;
